import { useEffect, useRef } from 'react'

export function useScrollAnimation(threshold = 0.15) {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const el = ref.current
    if (!el) return

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible')
          }
        })
      },
      { threshold },
    )

    // Observe the container itself
    observer.observe(el)

    // Also observe all .scroll-animate and .pop-animate children
    const children = el.querySelectorAll('.scroll-animate, .pop-animate')
    children.forEach((child) => observer.observe(child))

    return () => observer.disconnect()
  }, [threshold])

  return ref
}
